import { $subscriber, SystemMessage } from "fire-wind-water";

const $message = new SystemMessage();

// 参数 {type: 'sk-template-config', data: extra}
$message["sk-template-config"] = arg => {
  $subscriber.emit("sk-template-config", arg);
};

$message["sk-template-download"] = arg => {
  $subscriber.emit("sk-template-download", arg);
};

$message["sk-template-download-save"] = arg => {
  $subscriber.emit("sk-template-download-save", arg);
};

$message["sk-template-save-config"] = arg => {
  $subscriber.emit("sk-template-save-config", arg);
};

// 通知模板中心是否加载完毕，1为加载完毕，可以接受message事件
function $messageLoad(data) {
  $message.post({
    type: "sk-stemplate-loaded",
    data: data
  });
}

export { $message, $messageLoad };
